import { htmlToText } from "./Util";

export const htmlEllipsisCell = (value, limit = 20) => {
  const text = htmlToText(value);

  return text.length > limit ? text.substring(0, limit) + "..." : text;
};

export const ellipsisCell = (value, limit = 20) => {
  return value.length > limit ? value.substring(0, limit) + "..." : value;
};
